import * as actions from './actions';
import { chartTypes, charts, showAsOptions } from '../../utils/constants';

export type State = {
  selectedChart: Record<string, string>;
  selectedChartType: string;
  selectedDollarType: Record<string, string>;
  selectedAge: number;
  retirementShowAs: Record<string, string>;
  loading: boolean;
  simulationCurrentWant: Record<string, any>;
  simulationCurrentHave: Record<string, any>;
  error: Record<string, string>;
  initialLoad: boolean;
};

export default (
  state: State = {
    selectedChart: {
      id: charts.RETIREMENT_INCOME,
      title: 'Retirement Income Over Time',
      mobileTitle: 'Retirement Income',
    },
    selectedChartType: chartTypes.WANT,
    selectedDollarType: { name: "today's dollars", value: 'todaysDollars' },
    selectedAge: 0,
    retirementShowAs: showAsOptions[0],
    loading: false,
    simulationCurrentWant: {},
    simulationCurrentHave: {},
    error: {},
    initialLoad: true,
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.SELECT_CHART:
      return {
        ...state,
        selectedChart: action.payload,
      };
    case actions.SELECT_CHART_TYPE:
      return {
        ...state,
        selectedChartType: action.payload,
      };
    case actions.SELECT_DOLLAR_TYPE:
      return {
        ...state,
        selectedDollarType: action.payload,
      };
    case actions.SELECT_AGE:
      return {
        ...state,
        selectedAge: action.payload,
      };
    case actions.TOGGLE_RETIREMENT_SHOW_AS:
      return {
        ...state,
        retirementShowAs: action.payload,
      };
    case actions.FETCH_SIMULATION_CURRENT_WANT:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_SIMULATION_CURRENT_WANT_SUCCESS:
      return {
        ...state,
        simulationCurrentWant: action.payload,
        loading: false,
      };
    case actions.FETCH_SIMULATION_CURRENT_WANT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.FETCH_SIMULATION_CURRENT_HAVE:
      return {
        ...state,
        loading: true,
        initialLoad: false,
      };
    case actions.FETCH_SIMULATION_CURRENT_HAVE_SUCCESS:
      return {
        ...state,
        simulationCurrentHave: action.payload,
        loading: false,
      };
    case actions.FETCH_SIMULATION_CURRENT_HAVE_ERROR:
      return {
        ...state,
        error: action.payload,
        simulationCurrentHave: {},
        loading: false,
      };
    case actions.POST_SIMULATION:
      return {
        ...state,
        loading: true,
        initialLoad: false,
        selectedChart: {
          id: charts.RETIREMENT_INCOME,
          title: 'Retirement Income Over Time',
          mobileTitle: 'Retirement Income',
        },
        simulationCurrentHave: {},
        selectedChartType: chartTypes.WANT,
      };
    default:
      return state;
  }
};
